import { createReducer, Action, on } from '@ngrx/store';
import {
    createFormGroupState,
    onNgrxForms,
    updateGroup,
    onNgrxFormsAction,
    SetValueAction,
    wrapReducerWithFormStateUpdate,
} from 'ngrx-forms';
import { IInvestmentsState, InvestmentsModel } from './state';
import { AllocateAllToOptionAction, InvestmentOptionsListResponseAction, ResetDataSavedAction, SaveInvestmentOptionsResponseActions, SetUpdatedOptionsAction, UpdateManualSplitSelectedAction } from './actions';
import { Helper } from '@ifaa-components/ui-components';

const formName = 'investmentsForm';

const helper: Helper = new Helper();

const defaultState: IInvestmentsState = {
    form: createFormGroupState(formName, new InvestmentsModel()),
    dataSaved: false,
    investmentOptions: null,
    isManualSplit: false,
};

const validateInvestments = updateGroup<InvestmentsModel>({
});

const reducer = createReducer(
    defaultState,
    onNgrxForms(),
    onNgrxFormsAction(SetValueAction, (state, _action) => {
        return state;
    }),
    on(InvestmentOptionsListResponseAction, (state, { investmentOptions }) => {
        return {
            ...state,
            investmentOptions,
        }
    }),
    on(ResetDataSavedAction, (state) => {
        return {
            ...state,
            dataSaved: false
        }
    }),
    on(SaveInvestmentOptionsResponseActions, (state) => {
        return {
            ...state,
            dataSaved: true
        }
    }),
    on(UpdateManualSplitSelectedAction, (state, { isManualSplit }) => {
        return {
            ...state,
            isManualSplit
        }
    }),
    on(SetUpdatedOptionsAction, (state, { investmentOptions }) => {
        var val = helper.clone(state.form.value);
        var investmentClone = helper.clone(investmentOptions);

        investmentClone.forEach(investment => {
            investment.percentage = 0;
        })

        val.investments = investmentClone;

        return {
            ...state,
            investmentOptions,
            form: createFormGroupState(formName, val)
        }
    }),
    on(AllocateAllToOptionAction, (state, { investmentOptionId }) => {
        var val = helper.clone(state.form.value);

        val.investments.forEach(investment => {
            investment.percentage = 0;
        })

        var option = val.investments.find(x => x.investmentOptionId === investmentOptionId);
        option.percentage = 100;

        return {
            ...state,
            form: createFormGroupState(formName, val)
        }
    })
);

const editInvestmentsVerificationDataFormState = wrapReducerWithFormStateUpdate(
    reducer,
    s => s.form,
    validateInvestments
)

export function investmentsReducer(state: any | undefined, action: Action) {
    return editInvestmentsVerificationDataFormState(state, action);
}
